import React, { useState, useEffect } from 'react';

interface DoubleClickButtonProps {
    onDoubleClick: () => void;
    text: string;
    className?: string;
}

export const DoubleClickButton: React.FC<DoubleClickButtonProps> = ({ onDoubleClick, text, className }) => {
    const [clickCount, setClickCount] = useState<number>(0);
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

    const handleClick = () => {
        if (clickCount === 0) {
            setClickCount(1);
            const newTimer = setTimeout(() => {
                setClickCount(0);
            }, 300); // Устанавливаем таймаут на 300 мс для второго клика
            setTimer(newTimer);
        } else {
            if (timer) {
                clearTimeout(timer);
            }
            setClickCount(0);
            onDoubleClick();
        }
    };

    useEffect(() => {
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [timer]);

    return (
        <button className={ className || '' } onClick={handleClick}>{ text }</button>
    );
};